import { Section, SectionTitle, StatusItem, StatusValue } from './styles';

import { useAppSelector } from 'features/app/hooks';
import {
  selectSwitchboardConnections,
  selectWebRtcRemoteIdentities,
} from 'features/caller-session/store';
import { RtcSessionTracker } from 'features/sip/services';

export const ConnectionTab = () => {
  const webRtcConnections = useAppSelector(selectWebRtcRemoteIdentities);
  const switchboardConnections = useAppSelector(selectSwitchboardConnections);

  const directSession = RtcSessionTracker.getDirectSession();
  const teamingSession = RtcSessionTracker.getTeamingSession();
  const wavelloSession = RtcSessionTracker.getWavelloSession();
  const directSessionUri =
    directSession?.remote_identity?.uri?.toString() || 'None';
  const teamingSessionUri =
    teamingSession?.remote_identity?.uri?.toString() || 'None';
  const wavelloSessionUri =
    wavelloSession?.remote_identity?.uri?.toString() || 'None';

  return (
    <Section>
      <SectionTitle variant='subtitle2'>Connection Status</SectionTitle>
      <StatusItem>
        WebRTC Connections:{' '}
        <StatusValue>{webRtcConnections?.length || 0}</StatusValue>
      </StatusItem>
      <StatusItem>
        Switchboard:{' '}
        <StatusValue>{switchboardConnections?.length || 0}</StatusValue>
      </StatusItem>
      <StatusItem>
        Direct Session URI: <StatusValue>{directSessionUri}</StatusValue>
      </StatusItem>
      <StatusItem>
        Teaming Session URI: <StatusValue>{teamingSessionUri}</StatusValue>
      </StatusItem>
      <StatusItem>
        Wavello Session URI: <StatusValue>{wavelloSessionUri}</StatusValue>
      </StatusItem>
    </Section>
  );
};
